import React, { useContext, useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Tooltip from "App/common/ui/Tooltip";
// import { TOOLTIPS } from "consts";
import Loader from "App/common/ui/Loader";
import { deepCompare, forbidExtraProps } from "utils";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import { LayoutContext } from "App/common/hoc/Layout";
import { deepClone } from "utils";

import { updateVMConfigurationsStart, resetSliderConfigs } from "store/actions";

import { ReactComponent as NetworkSource } from "assets/images/app_svg/virtualization_network_source.svg";
import { ReactComponent as NetworkModel } from "assets/images/app_svg/virtualization_network_model.svg";
import { ReactComponent as StorageController } from "assets/images/app_svg/virtualization_storage_controller.svg";
import { ReactComponent as BootMenu } from "assets/images/app_svg/virtualization_bootmenu.svg";
import { ReactComponent as VideoGraphics } from "assets/images/app_svg/virtualization_video_graphics.svg";

function VMConfiguration(props) {
  const { sPopupState, sPopupMethods } = useContext(SPopupContext);
  const { lState, lMethods } = useContext(LayoutContext);
  const ramMemoryList = [1, 2, 4, 6, 8, 16];
  const [vmDetails, setVMDetails] = useState(
    deepClone(lState.slidingPopup.params)
  );

  const [enableBuildVMButton, setBuildVMButton] = useState(false);
  const [vmDetailsClone, setvmDetailsClone] = useState(deepClone(vmDetails));

  function calculateAvailableRam() {
    // const totalRam = 17179869184
    let ramFree = 17179869184;
    props.vmsList.forEach(vm => {
      if (vm.vm_uuid !== vmDetails.vm_uuid) {
        ramFree = ramFree - vm.memory;
      }
    });
    return ramFree;
  }

  useEffect(() => {
    if (!deepCompare(vmDetails, vmDetailsClone)) {
      setBuildVMButton(true);
    } else {
      setBuildVMButton(false);
    }
  }, [vmDetails]);

  const availableRam = calculateAvailableRam();

  function updateVMConfig() {
    delete vmDetails.id;
    delete vmDetails.vm_name;
    delete vmDetails.created_date;
    delete vmDetails.hostname;
    delete vmDetails.vnc_port;
    delete vmDetails.vnc_password;
    delete vmDetails.rec_point;
    delete vmDetails.os_type;
    delete vmDetails.status;
    delete vmDetails.vnc_host;
    delete vmDetails.extra_meta;
    delete vmDetails.connection_url;
    delete vmDetails.loading;
    if (vmDetails.network?.source === "disconnected") {
      vmDetails.network = null;
    }
    setBuildVMButton(false);
    props.updateVMConfigurationsStart(vmDetails);
  }

  useEffect(() => {
    if (props.vmSliderConfig.closeSlider) {
      setTimeout(() => {
        lMethods.closeSlidingPopup();
        setTimeout(() => {
          props.resetSliderConfigs();
        }, 1500);
      }, 2000);
    }
  }, [props.vmSliderConfig]);

  useEffect(() => {
    if (props.notification && props.notification.slidingPopup) {
      if (
        props.vmSliderConfig.updateSuccess ||
        props.vmSliderConfig.updateFailed
      ) {
        sPopupMethods.showNotify(props.notification.slidingPopup);
        setTimeout(() => {
          sPopupMethods.closeNotify();
        }, 2000);
      }
    }
  }, [props.notification]);

  return (
    <React.Fragment>
      {props.vmSliderConfig.loading ? (
        <Loader />
      ) : (
        <div className="slider_summary">
          <div className="slider_content_body">
            <div className="local_virtualization_slider">
              <div className="slider_wrap">
                <div className="computer_section">
                  <div
                    className="mirror_loader flex_center"
                    style={{ display: "none" }}
                  >
                    {" "}
                    <img
                      src="images/mirror_loader.gif"
                      alt="Mirror_Loader"
                    />{" "}
                    <span className="flex_center">Processing</span>{" "}
                  </div>
                  <div className="wrapper_box">
                    <div className="message_box">
                      <div
                        className="alert alert-danger alert-dismissible custom-alert buildError"
                        style={{ display: "none" }}
                      >
                        {" "}
                        <a
                          href="#"
                          className="close"
                          data-dismiss="alert"
                          aria-label="close"
                          title="close"
                        >
                          ×
                        </a>
                        <div className="align-center">
                          {" "}
                          <i className="icon"></i>
                          <div className="txt">This is a Error message.</div>
                        </div>
                      </div>

                      <div
                        className="alert alert-success alert-dismissible  custom-alert buildSuccess"
                        style={{ display: "none" }}
                      >
                        {" "}
                        <a
                          href="#"
                          className="close"
                          data-dismiss="alert"
                          aria-label="close"
                          title="close"
                        >
                          ×
                        </a>
                        <div className="align-center">
                          <div className="txt_2">
                            This is a success message.
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons processor"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>Processors :</label>
                          <div className="select_box main_select">
                            <select
                              value={vmDetails.processors}
                              onChange={e =>
                                setVMDetails({
                                  ...vmDetails,
                                  processors: e.target.value
                                })
                              }
                            >
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                            </select>
                            <span
                              className="error-msg"
                              style={{ display: "none" }}
                            >
                              The field cannot be blank
                            </span>{" "}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons ram"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>RAM :</label>
                          <div class="select_box main_select">
                            <select
                              value={vmDetails.memory}
                              name="ram"
                              onChange={e =>
                                setVMDetails({
                                  ...vmDetails,
                                  memory: +e.target.value
                                })
                              }
                            >
                              {ramMemoryList.map(
                                ram =>
                                  availableRam >= ram * 1024 * 1024 * 1024 && (
                                    <option
                                      key={ram}
                                      value={ram * 1024 * 1024 * 1024}
                                    >
                                      {ram} GB
                                    </option>
                                  )
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons network_source"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>
                            Network Source :
                            <Tooltip
                              title="Choose how the virtual instance should be attached to the network through IDrive Mirror"
                              placement="top"
                            >
                              <NetworkSource />
                            </Tooltip>
                          </label>
                          <div className="select_box main_select">
                            <select
                              value={
                                vmDetails.network
                                  ? vmDetails.network.source
                                  : "disconnected"
                              }
                              onChange={e => {
                                if (e.target.value === "disconnected") {
                                  setVMDetails({
                                    ...vmDetails,
                                    network: null
                                  });
                                } else {
                                  setVMDetails({
                                    ...vmDetails,
                                    network: {
                                      ...vmDetails.network,
                                      source: e.target.value,
                                      controller: "e1000"
                                    }
                                  });
                                }
                              }}
                            >
                              <option value="disconnected">Disconnected</option>
                              <option value="default">NAT (Firewalled)</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons network_model"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>
                            Network Model :
                            <Tooltip
                              title="Choose an appropriate virtual network adapter model"
                              placement="top"
                            >
                              <NetworkModel />
                            </Tooltip>
                          </label>
                          <div className="select_box main_select">
                            <select
                              value={
                                vmDetails.network
                                  ? vmDetails.network.controller
                                  : "e1000"
                              }
                              onChange={e =>
                                setVMDetails({
                                  ...vmDetails,
                                  network: {
                                    ...vmDetails.network,
                                    controller: e.target.value
                                  }
                                })
                              }
                              disabled={
                                vmDetails.network === null ||
                                vmDetails.network.source === "disconnected"
                              }
                            >
                              {vmDetails.network === null ||
                              vmDetails.network.source === "disconnected" ? (
                                <option selected="true">None</option>
                              ) : (
                                <React.Fragment>
                                  <option value="e1000">
                                    Intel 82545EM Gigabit Ethernet
                                  </option>
                                  {/* <option value="rtl8139">
                                    Realtek RTL8139 PCI Fast Ethernet
                                  </option>
                                  <option value="virtio">
                                    Paravirtualized Network (VirtIO)
                                  </option> */}
                                </React.Fragment>
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons storage_controller"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>
                            Storage Controller :
                            <Tooltip
                              title="Choose an appropriate storage controller, which closely matches with the storage controller used on the machine"
                              placement="top"
                            >
                              <StorageController />
                            </Tooltip>
                          </label>
                          <div className="select_box main_select">
                            <select
                              value={vmDetails.storage_params.target_bus}
                              onChange={e =>
                                setVMDetails({
                                  ...vmDetails,
                                  storage_params: {
                                    target_bus: e.target.value
                                  }
                                })
                              }
                            >
                              <option value="sata">SATA</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons graphics"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>
                            Graphics :
                            <Tooltip
                              title="QXL is recommended for newer operating systems. Select VGA for older operating systems."
                              placement="top"
                            >
                              <VideoGraphics />
                            </Tooltip>
                          </label>
                          <div className="select_box main_select">
                            <select
                              value={vmDetails.video}
                              onChange={e =>
                                setVMDetails({
                                  ...vmDetails,
                                  video: e.target.value
                                })
                              }
                            >
                              <option value="qxl">QXL</option>
                              <option value="vga">VGA</option>
                              {/* <option value="cirrus">CIRRUS</option> */}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row_box ">
                      <div className="lhs_box ">
                        <div className="lhs_box_icons boot_menu"></div>
                      </div>
                      <div className="rhs_box">
                        <div className="input_field">
                          <label>
                            Enable boot menu
                            <Tooltip
                              title="Enable BIOS boot menu during VM startup"
                              placement="top"
                            >
                              <BootMenu />
                            </Tooltip>
                          </label>
                          <div className="check_box enable_boot_menu">
                            <div class=" boot__btn">
                              <label class="switch">
                                <input
                                  type="checkbox"
                                  checked={
                                    vmDetails.boot_params.enable === "yes"
                                  }
                                  onClick={e =>
                                    setVMDetails({
                                      ...vmDetails,
                                      boot_params: {
                                        ...vmDetails.boot_params,
                                        enable:
                                          vmDetails.boot_params.enable === "no"
                                            ? "yes"
                                            : "no",
                                        timeout:
                                          vmDetails.boot_params.timeout < 3
                                            ? 3
                                            : vmDetails.boot_params.timeout
                                      }
                                    })
                                  }
                                />
                                <span
                                  class={[
                                    "slider round ",
                                    vmDetails.boot_params.enable === "yes"
                                      ? "enabledOn"
                                      : "enabledOff"
                                  ].join(" ")}
                                ></span>
                              </label>
                            </div>
                            <div className="text_box ">
                              <input
                                type="number"
                                min="3"
                                max="60"
                                maxLength="2"
                                className="input_text w_80"
                                value={vmDetails.boot_params.timeout / 1000}
                                disabled={vmDetails.boot_params.enable === "no"}
                                onKeyDown={e => {
                                  // Prevent unwanted characters: decimals, negative signs, and the "e" key (scientific notation)
                                  if (
                                    e.key === "." ||
                                    e.key === "-" ||
                                    e.key.toLowerCase() === "e"
                                  ) {
                                    e.preventDefault(); // Prevent the default input behavior
                                  }
                                }}
                                onChange={e => {
                                  if (
                                    +e.target.value <= 60 &&
                                    +e.target.value >= 3
                                  ) {
                                    setVMDetails({
                                      ...vmDetails,
                                      boot_params: {
                                        ...vmDetails.boot_params,
                                        timeout: +e.target.value * 1000
                                      }
                                    });
                                  }
                                }}
                              />
                              <span
                                className="img_info_icon"
                                tooltipwidth="190"
                              ></span>
                              <span className="txt">Timeout in seconds</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="slider_content_footer">
                <div className="slider_summary_btns">
                  <div className="slider_summary_btns__inner">
                    <div className="backup_image_btns ">
                      <div
                        className={[
                          "slider_btn full_img_backup_btn btn_primary btn_create_machine",
                          enableBuildVMButton ? "" : "btn_disable"
                        ].join(" ")}
                        onClick={() => {
                          if (enableBuildVMButton) {
                            updateVMConfig();
                          }
                        }}
                      >
                        Update
                      </div>
                    </div>
                    {/* <div className="loader" style={{ display: "none" }}>
                                    <div className="loader__image">
                                        <div className="loader__progress progress">
                                            <div className="progress__bar"></div>
                                            <div className="progress__value">0</div>
                                        </div>
                                    </div>
                                </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

VMConfiguration.propTypes = forbidExtraProps(
  {
    vmsList: PropTypes.arrayOf(PropTypes.object),
    notification: PropTypes.shape({
      status: PropTypes.oneOf([0, 1]),
      msg: PropTypes.string
    }),
    vmSliderConfig: PropTypes.object
  },
  ["dispatch", "updateVMConfigurationsStart", "resetSliderConfigs"]
);

function mapStateToProps(state) {
  return {
    vmsList: state.virtualization.vmsList,
    vmSliderConfig: state.virtualization.sliderConfig,
    notification: state.common.notification
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateVMConfigurationsStart,
      resetSliderConfigs
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(VMConfiguration);

// export default VMConfiguration;
